// extracted by mini-css-extract-plugin
export default {"anchor-tag--image":"AnchorTag_anchor-tag--image__pM1Zn"};